import * as batch from './_batch';
import * as document from './_document';
import * as field from './_field';
import * as page from './_page';
import * as process from './_process';
import { extractOCR, isPointInPolygon } from './ocr/_extract';
import { isPosition, isPositionsGeneral, normalizeBox, useGetDocumentOCRPositionByDocumentFetcher, useGetPageOCRPositionFetcher } from './ocr/_position';
import { createOCRShapeConfig, createOCRShapesIterator, createShapeId, getHighlightShapeStyle, getOCRShapeStyle, getSelectorRectStyle } from './ocr/_shape';
import { useBatchValidator } from './validate/_validator';

/** Process logic. */
const processLogic = {
  process,
  batch,
  document,
  page,
  field,
  validate: {
    useBatchValidator,
  },
  ocr: {
    isPosition,
    isPositionsGeneral,
    normalizeBox,
    useGetPageOCRPositionFetcher,
    useGetDocumentOCRPositionByDocumentFetcher,

    createShapeId,
    createOCRShapeConfig,
    createOCRShapesIterator,
    getOCRShapeStyle,
    getSelectorRectStyle,
    getHighlightShapeStyle,

    isPointInPolygon,
    extractOCR,
  },
};

export type { CreateSaveBatchRequestDataOptions, ProcessBatchFormField } from './_process.type';
export type { BatchFieldsFormField } from './_batch.type';
export type { DocumentFieldsFormField, DocumentFieldsFormFieldItem } from './_document.type';
export type { PageStatus } from './_page.type';
export type { BatchValidator } from './validate/_validator.type';
export type { OCRShape, OCRShapeStatus as ValueRectStatus } from './ocr/_shape.type';
export type { Lasso, LassoField, LassoFieldGeneral, LassoFieldTable, LassoMode, LassoPosition } from './ocr/_lasso.type';
export type { DocumentOCRPosition } from './ocr/_position.type';

export default processLogic;
